import { i18n } from "@lib/i18n";
import { globalLayoutRoute } from "@routes";
import { requireScope } from "@routes/authorization";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export const preselectionRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `preselection/$taskId`,
    beforeLoad: () => {
        requireScope("account");
        return { getTitle: () => i18n.doc_title_preselection() };
    },
    component: lazyRouteComponent(() => import("./Preselection"), "Preselection"),
});
